/**
 * @file: 构建图纸保存数据
 * @author: xiaolong.huang@dmall.com
 */

import Utils from '../utils/util';
import Update from '../update/index';
import Config from '../config';
import { getCubeTreeData } from './treeData';
import { isShelf, isFreezer } from './cubeInfo';
import { findSketchpad } from './advanceQuery';

function makeSaveDataTree(): SaveDataTree {
    let stage: CubeId = findSketchpad();
    let stageTreeData: CubeTreeData = getCubeTreeData(stage);
    let result: SaveDataTree = {
        id: stageTreeData.id,
        type: stageTreeData.type,
        moduleName: stageTreeData.moduleName,
        tplName: stageTreeData.tplName,
        cubeName: stageTreeData.cubeName,
        desc: stageTreeData.desc,
        frontCubeData: stageTreeData.frontCubeData,
        cubeData: stageTreeData.cubeData,
        cubes: [],
        uuid: shelvesLogUUID, // window.shelvesLogUUID 从全局取，待重构
        dirtyArr: [], // 存画布上的组件
        textboxList: []
    };

    stageTreeData.cubes.forEach((cube: CubeTreeData): void => {
        if (isShelf(cube.id) || isFreezer(cube.id)) {
            result.cubes.push(wrapShelf(Utils.deepCopy(cube)));
            return;
        }

        result.dirtyArr.push(Utils.deepCopy(cube));
    });
    addVersion(result);
    return result;
}

function addVersion(saveData: SaveDataTree): void {
    const version: string = Config.get({
        moduleName: 'base',
        key: 'version'
    });
    let remark: string = Utils.isJsonString(saveData.cubeData.remark) ? saveData.cubeData.remark : '{}';
    let remarkObj: FreeObjMap = JSON.parse(remark);

    remarkObj.version = version;
    saveData.cubeData.remark = JSON.stringify(remarkObj);
}

function wrapShelf(shelf: CubeTreeData): FreeObjMap {
    return {
        id: '',
        type: 'elements',
        moduleName: 'shelves',
        tplName: 'box',
        cubeName: 'shelvesbuild-e-shelves-box',
        desc: '开放式货架',
        cubes: [shelf]
    };
}

export {
    makeSaveDataTree
};
